
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

// Função para salvar votos de sabores
export const saveFlavorVote = async (flavorId: string) => {
  try {
    const { error } = await supabase
      .from('flavor_votes')
      .insert([{ flavor_id: flavorId }]);
    
    if (error) throw error;
    return true;
  } catch (error) {
    console.error('Erro ao salvar voto:', error);
    toast({
      title: "Ops! Algo deu errado",
      description: "Não foi possível registrar seu voto. Por favor tente novamente.",
      variant: "destructive",
    });
    return false;
  }
};

// Função para buscar a contagem de votos
export const getFlavorVotes = async (): Promise<Record<string, number>> => {
  try {
    const { data, error } = await supabase
      .from('flavor_votes')
      .select('flavor_id');
    
    if (error) throw error;
    
    // Contagem de votos por sabor
    const voteCounts: Record<string, number> = {};
    data.forEach(vote => {
      voteCounts[vote.flavor_id] = (voteCounts[vote.flavor_id] || 0) + 1;
    });
    
    return voteCounts;
  } catch (error) {
    console.error('Erro ao buscar votos:', error);
    return {};
  }
};

// Função para salvar contatos
export const saveContact = async (name: string, email: string, phone?: string) => {
  try {
    // 1. Salvar na tabela contacts
    const { error } = await supabase
      .from('contacts')
      .insert([{ name, email, phone }]);
    
    if (error) throw error;
    
    // 2. Chamar a função Edge para enviar e-mail
    const { data: sessionData } = await supabase.auth.getSession();
    
    const response = await fetch("https://dzgocgmnozogkpbadfke.supabase.co/functions/v1/send-email", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${sessionData.session?.access_token || ''}`,
      },
      body: JSON.stringify({ name, email, phone }),
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Falha no envio do e-mail");
    }
    
    return true;
  } catch (error) {
    console.error('Erro ao salvar contato:', error);
    toast({
      title: "Ops! Algo deu errado",
      description: "Não foi possível registrar seu contato. Por favor tente novamente.",
      variant: "destructive",
    });
    return false;
  }
};
